module.exports = __webpack_public_path__ + "img/home4.edb2b231.png";